import { enviarEmail } from '@/api/errors';

function printConsole(error) {
  /* eslint-disable no-console */
  if (!error) {
    console.log('Error no controlado');
    return;
  }

  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  }
  if (error.message) {
    console.log(error.message);
  } else {
    console.log(error);
  }
  if (error.config) {
    console.log('"Error config:', error.config);
  }
  /* eslint-enable no-console */
}

function print(error) {
  if (error instanceof Array || Object.prototype.toString.call(error) === '[object Array]') {
    error.forEach(e => {
      printConsole(e);
    });
  } else {
    printConsole(error);
  }
}

function reportarError(payload) {
  // Mostramos error en la consola
  print(payload);
  // Enviamos corro
  enviarEmail(payload).catch(error => {
    print(error);
  });
}

const logger = {
  print,
  reportarError
};

export default logger;
